/** Controlled screens the Super Admin sets access for. Matches AccessScreen.key() on the server. */
export type ScreenKey = 'planning';

/** Matches ScreenAction on the server. Any action implies VIEW. */
export type ScreenAction = 'VIEW' | 'CREATE' | 'EDIT' | 'DELETE';

export const SCREEN_ACTIONS: readonly ScreenAction[] = ['VIEW', 'CREATE', 'EDIT', 'DELETE'];

/** What the signed-in user may do on one screen (GET /api/screen-access/{screen}/me). */
export interface MyScreenAccess {
  screen: ScreenKey;
  roleId: number | null;
  actions: ScreenAction[];
}

/** One role's line on the Screen Access page. `locked`: Super Admin, always every action. */
export interface RoleAccessRow {
  roleId: number;
  roleName: string;
  actions: ScreenAction[];
  defaultActions: ScreenAction[];
  locked: boolean;
}

export interface ScreenAccessMatrix {
  screen: ScreenKey;
  label: string;
  companyRefId: number;
  allActions: ScreenAction[];
  roles: RoleAccessRow[];
  /** False while the screen still runs on its built-in defaults. */
  customized: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
}

export interface RoleAccessUpdate {
  roleId: number;
  actions: ScreenAction[];
}
